import { Record } from "immutable";

const DataSourceValueRecord = Record({
  entityId: "",
  positive: true
});

export default DataSourceValueRecord;
